import { arrayOf, object, string } from 'prop-types';
import React from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import BreadCrumbs from 'yoda-core-components/lib/components/BreadCrumbs/BreadCrumbs';
import Crumbs from 'yoda-core-components/lib/components/BreadCrumbs/BreadCrumbs/Crumbs';
import PageTitle from '../PageTitle/PageTitle';

const renderCrumbs = (breadCrumbs, theme, automationId, locPath) => {
    return breadCrumbs?.length > 1 ? (
        <div className={dt([`text-${theme}`])} data-automation-id={automationId}>
            <BreadCrumbs separator="arrow">
                {!locPath
                    ? breadCrumbs.map((crumbs, index) => {
                          let crumbsHtml;
                          if (crumbs?.urlHolder?.value) {
                              crumbsHtml = (
                                  <Crumbs key={index.toString()} path={crumbs?.urlHolder?.value}>
                                      {crumbs?.breadcrumb}
                                  </Crumbs>
                              );
                          } else {
                              crumbsHtml = (
                                  <Crumbs key={index.toString()} isActive>
                                      {crumbs?.breadcrumb}
                                  </Crumbs>
                              );
                          }

                          return crumbsHtml;
                      })
                    : breadCrumbs.map((crumbs, index) => {
                          let crumbsHtml;
                          if (crumbs?.pageUrl) {
                              crumbsHtml = (
                                  <Crumbs key={index.toString()} path={crumbs?.pageUrl}>
                                      {crumbs?.breadCrumbLabel}
                                  </Crumbs>
                              );
                          } else {
                              crumbsHtml = (
                                  <Crumbs key={index.toString()} isActive>
                                      {crumbs?.breadCrumbLabel}
                                  </Crumbs>
                              );
                          }

                          return crumbsHtml;
                      })}
            </BreadCrumbs>
        </div>
    ) : (
        <></>
    );
};

const renderBreadCrumbsScheme = (breadCrumbs, reqPagePath, hostName, locPath) => {
    const crumbsHtml = [];
    !locPath
        ? breadCrumbs?.map((crumbs, index) => {
              crumbsHtml.push({
                  '@type': 'ListItem',
                  position: index + 1,
                  item: {
                      '@id': crumbs?.urlHolder?.value
                          ? hostName + crumbs?.urlHolder?.value
                          : hostName + reqPagePath, // if no path, take the current page url
                      name: crumbs?.breadcrumb,
                  },
              });
          })
        : breadCrumbs?.map((crumbs, index) => {
              crumbsHtml.push({
                  '@type': 'ListItem',
                  position: index + 1,
                  item: {
                      '@id': crumbs?.pageUrl ? hostName + crumbs?.pageUrl : hostName + reqPagePath, // if no path, take the current page url
                      name: crumbs?.breadCrumbLabel,
                  },
              });
          });

    const schemeDt = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: crumbsHtml,
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schemeDt) }}
        />
    );
};

const renderBreadCrumbs = (
    breadCrumbs,
    reqPagePath,
    hostName,
    theme,
    automationId,
    isCMPageEnabled,
    title
) => {
    const locPath = reqPagePath.includes('/d/');
    const brdCrumb = !locPath
        ? breadCrumbs?.filter((el) => el?.breadcrumb?.toLowerCase() !== 'jcpenney')
        : breadCrumbs?.filter((el) => el?.breadCrumbLabel?.toLowerCase() !== 'jcpenney');
    return breadCrumbs?.length ? (
        <>
            {renderCrumbs(brdCrumb, theme, automationId, locPath)}
            <PageTitle isCMPageEnabled={isCMPageEnabled} title={title} />
            {renderBreadCrumbsScheme(breadCrumbs, reqPagePath, hostName, locPath)}
        </>
    ) : null;
};

export const BreadCrumbNav = ({
    breadCrumbs,
    theme,
    automationId,
    reqPagePath,
    hostName,
    isCMPageEnabled,
    title,
}) => {
    return renderBreadCrumbs(
        breadCrumbs,
        reqPagePath,
        hostName,
        theme,
        automationId,
        isCMPageEnabled,
        title
    );
};

BreadCrumbNav.propTypes = {
    breadCrumbs: arrayOf(object).isRequired,
    theme: string,
    reqPagePath: string,
    hostName: string,
    automationId: string,
};

BreadCrumbNav.defaultProps = {
    breadCrumbs: [],
    theme: 'left',
    reqPagePath: '',
    hostName: '',
    automationId: '',
};

export default BreadCrumbNav;
